import {
  KIT_TYPE_US,
  KIT_TYPE_GLOBAL,
  WAREHOUSE_ITEM,
  ON_DEMAND_ITEM,
} from "@stadium/constants/kits";
import { GLOBAL_COUNTRY, US_COUNTRY } from "@constants/country";

export const US_KIT_INFO =
  "Send your global kit to US recipients, or create a US kit to maximize our larger US catalog.";

export const GLOBAL_KIT_INFO =
  "If you want to send a kit to non-US recipients, you'll need to create a global kit.";

export const KIT_COUNTRIES_MAPPING = {
  [KIT_TYPE_US]: US_COUNTRY,
  [KIT_TYPE_GLOBAL]: GLOBAL_COUNTRY,
};

export const DESCRIPTION_MAPPING = {
  [KIT_TYPE_US]: () => US_KIT_INFO,
  [KIT_TYPE_GLOBAL]: ({ fee, onlyUSWarehouseItems }) =>
    onlyUSWarehouseItems
      ? `If you want to send a kit to non-US recipients, create a global kit or send your US kit globally ($${fee}/recipient plus fulfillment fee).`
      : GLOBAL_KIT_INFO,
};

export const KIT_COLUMNS = [KIT_TYPE_US, KIT_TYPE_GLOBAL];

export const PRODUCT_TYPES = [
  {
    type: ON_DEMAND_ITEM,
    title: "On-Demand Items",
  },
  {
    type: WAREHOUSE_ITEM,
    title: "Warehouse Items",
  },
];

export const TOOLTIP_TEXT = {
  [KIT_TYPE_US]: {
    [WAREHOUSE_ITEM]: () => "These items will be shipped from our US warehouse together.",
    [ON_DEMAND_ITEM]: () =>
      "These items may be shipped to your recipients separately. They’ll be printed when your recipient redeems.",
  },
  [KIT_TYPE_GLOBAL]: {
    [WAREHOUSE_ITEM]: (fee) =>
      `These items will be shipped from our US warehouse for an additional fee ($${fee}/recipient plus fulfillment fee).`,
    [ON_DEMAND_ITEM]: () =>
      "These items may be shipped to your recipients separately. They’ll be printed when your recipient redeems.",
  },
};
